import React, { useEffect, startTransition } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/v4_img/v4_logo.png';
import KakaoLoginButtonV4 from '../../component/V4/KakaoLoginButtonV4';

function StartV4() {

  const navigate = useNavigate();

  // 페이지가 로드될 때 실행되는 useEffect를 이용하여 로컬 스토리지에 저장 및 상태 설정
  useEffect(() => {
    // 이미 from 값이 있으면 덮어쓰지 않음 (다른 페이지에서 설정한 값 유지)
    const existingFrom = localStorage.getItem('from');
    if (existingFrom) {
      return; // 이미 설정된 from 값 유지
    }

    // URL에서 동적으로 from 값 결정 (직접 접근한 경우에만)
    const currentPath = window.location.pathname;
    // Legacy로 이동: Transit은 더 이상 사용하지 않음
    // if (currentPath.includes('Transit')) {
    //   localStorage.setItem('from', 'Transit');
    // }
    if (currentPath.includes('StudyCafe')) {
      localStorage.setItem('from', 'StudyCafe');
    } else if (currentPath.includes('Sparta')) {
      localStorage.setItem('from', 'Sparta');
    } else if (currentPath.includes('Wellness')) {
      localStorage.setItem('from', 'Wellness');
    } else {
      localStorage.setItem('from', 'Start');
    }
  }, []);



  const handlePhoneLogin = () => {
    // 전화번호 입력 페이지로 이동
    startTransition(() => {
      navigate('/V4/PhoneNumber');
    });
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(180deg, #fff 0%, #FFEFEF 100%)', 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'center', 
      alignItems: 'center',
    }}>
      {/* 로고와 Account 텍스트 */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'center', 
        marginBottom: '60px',
        gap: '12px'
      }}>
        <img 
          src={logo} 
          alt="V4 로고" 
          style={{ 
            width: '36px', 
            height: '36px'
          }} 
        />
        <span style={{
          color: '#000',
          fontFamily: 'Pretendard',
          fontSize: '38px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: 'normal',
          letterSpacing: '-0.756px'
        }}>
          Account
        </span>
      </div>

      {/* 키치한 버튼들 */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%',
        maxWidth: '320px'
      }}>
        {/* 전화번호 버튼 */}
        <div 
          onClick={handlePhoneLogin}
          style={{
            display: 'flex',
            padding: '14px 40px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            borderRadius: '12px',
            border: '2px solid #000',
            background: '#FF7051',
            boxShadow: '4px 4px 0 0 #000',
            cursor: 'pointer',
            color: '#000',
            textAlign: 'center',
            fontFamily: 'Pretendard',
            fontSize: '17px',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '22px',
            transition: 'all 0.1s ease'
          }}
          onMouseDown={(e) => {
            e.target.style.transform = 'translate(2px, 2px)';
            e.target.style.boxShadow = '2px 2px 0 0 #000';
          }}
          onMouseUp={(e) => {
            e.target.style.transform = 'translate(0, 0)';
            e.target.style.boxShadow = '4px 4px 0 0 #000';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translate(0, 0)';
            e.target.style.boxShadow = '4px 4px 0 0 #000';
          }}
        >
          전화번호로 시작하기
        </div>

        {/* 카카오 버튼 */}
        <KakaoLoginButtonV4 />
      </div>
    </div>
  );
}

export default StartV4;
